<template>
    <div>
        <!-- <v-card v-if="!!territory">
            <v-toolbar flat color="primary" dark height="40" >
                <v-toolbar-title>{{territory.id}}</v-toolbar-title>
            </v-toolbar>
            <v-list dense>
                <v-list-tile>
                <v-list-tile-content class="body-2">Name</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ territory.name }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                <v-list-tile-content class="body-2">Active</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ territory.active ? "Active" : "Inactive" }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                <v-list-tile-content class="body-2">Sales Reps</v-list-tile-content>
                <v-list-tile-content class="align-end" v-for="user in territory.salesReps" :key="user.id">
                    {{ region.managerName }}
                </v-list-tile-content>
                </v-list-tile>
            </v-list>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.prevent="onEditTerritory(territory.id)">Edit</v-btn>
                <v-btn @click.prevent="onCloseTerritory">Close</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>

        </v-card> -->
        <v-card>
            <v-toolbar flat color="primary" dark height="40" >
                <v-toolbar-title>{{territory.id}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small @click.prevent='onEditTerritory(territory.id)'
                    light v-if="territory.active">Edit</v-btn>
                <v-btn small @click.prevent='onInactiveTerritory(territory.id)'
                    light v-if="territory.active"
                    >Deactivate</v-btn>
                <v-btn small @click.prevent='onActiveTerritory(territory.id)'
                    light v-if="!territory.active"
                    >Activate</v-btn>
                <v-btn icon light color="white" @click="onCloseTerritoryCard" 
                    v-show="showCloseButton">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-list dense>
                <v-list-tile>
                <v-list-tile-content class="body-2">Name</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ territory.name }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                <v-list-tile-content class="body-2">Import Source</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ territory.source }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                <v-list-tile-content class="body-2">Region</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ territory.regionId }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                <v-list-tile-content class="body-2">Active</v-list-tile-content>
                <v-list-tile-content class="align-end" :class="territory.active? 'success--text' : 'error--text'">{{ territory.active ? "Active" : "Inactive" }}</v-list-tile-content>
                </v-list-tile>
            </v-list>
            <v-layout row wrap px-2>
                <v-flex body-2 xs6 pl-2 >Regional Manager</v-flex>
                <v-flex xs6 >
                    <div xs6 >
                        {{territory.regionalMgrName}}
                    </div>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-if="territory.salesReps" px-2>
                <v-flex body-2 xs6 pl-2 >Sales Reps.</v-flex>
                <v-flex xs6 >
                    <div xs6 v-for="rep in territory.salesReps" :key="rep.id">
                        {{rep.name}}
                    </div>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-if="territory.csReps" px-2>
                <v-flex body-2 xs6 pl-2 >Cust. Serv. Reps.</v-flex>
                <v-flex xs6>
                    <div v-for="rep in territory.csReps" :key="rep.id">
                        {{rep.name}}
                    </div>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-if="territory.isReps" px-2>
                <v-flex body-2 xs6 pl-2 >Inside Sales Reps.</v-flex>
                <v-flex xs6 >
                    <div v-for="rep in territory.isReps" :key="rep.id">
                        {{rep.name}}
                    </div>

                </v-flex>
            </v-layout>

        </v-card>
        
    </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    props: ['territory', 'showCloseButton'],
    data() {
        return {
        }
    },
    methods: {
        ...mapActions('adminMarket', [
            'inactiveOrActiveTerritory'
        ]),
        onEditTerritory(id) {
            this.$emit('onEditTerritory', id)
        },
        async onInactiveTerritory(id) {
            // console.log('id:' + id)
            var payload = {
                id: id,
                changeTo: false,
            }
            var result = await this.inactiveOrActiveTerritory(payload)

            console.log(result)
            if(result === 'successful') {
                this.$emit('onTerritorySaved')
            } else {
                alert(result)
            }

        },
        async onActiveTerritory(id) {
            // console.log('id:' + id)
            var payload = {
                id: id,
                changeTo: true,
            }
            var result = await this.inactiveOrActiveTerritory(payload)
            
            if(result === 'successful') {
                this.$emit('onTerritorySaved')
            } else {
                alert(result)
            }
        },
        onCloseTerritoryCard() {
            this.$emit('onCloseTerritoryCard')
        },
    },

}
</script>
